// assets
import { DashboardOutlined, DollarOutlined, FormOutlined, CheckCircleOutlined } from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  DollarOutlined,
  FormOutlined,
  CheckCircleOutlined
};


// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/app/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'vx-purchase',
      title: 'Purchase Verification',
      type: 'item',
      url: '/app/vx-purchase',
      icon: icons.DollarOutlined
    },
    {
      id: 'vx-account',
      title: 'Prepaid Verification',
      type: 'item',
      url: '/app/verifications/vx-account',
      icon: icons.CheckCircleOutlined

    },
    {
      id: 'vx-release-forms',
      title: 'Release Forms',
      type: 'item',
      url: '/app/releaseForms/release-forms',
      icon: icons.FormOutlined
    }    
  ]
};

export default dashboard;
